import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { BankAccount } from '../interfaces/bank-account.interface';



interface AccountListProps {
  accounts: BankAccount[];
  amountToDeposit?: number;
  onDeposit: (accountId: number, bankName: string, accountNumber: string, accountRoutingNumber: string) => void;
  confirmDeleteAccount: (id: number) => void;
}


const AccountList: React.FC<AccountListProps> = ({ accounts, amountToDeposit, onDeposit, confirmDeleteAccount }) => {
  return (
    <Row className="g-4 mt-2">
      {accounts.map((account) => (
        <Col xs={12} md={12} lg={12} key={account.id}>
          <Card className="shadow-sm">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Card.Title className="mb-0 text-start">
                <i className="bi bi-bank"></i> Bank Account: {account.bankName}
              </Card.Title>
              <Button
                variant="danger"
                size="sm"
                onClick={() => confirmDeleteAccount(account.id)}
              >
                <i className="bi bi-trash3"></i>
              </Button>
            </Card.Header>
            <Card.Body>
              <Row className="mb-3">
                <Col xs={6} className="text-start"><strong>Bank Account Number</strong></Col>
                <Col xs={6} className="text-end">{account.accountNumber}</Col>
              </Row>
              <Row className="mb-3">
                <Col xs={6} className="text-start"><strong>Bank Routing Number</strong></Col>
                <Col xs={6} className="text-end">{account.routingNumber}</Col>
              </Row>
              {amountToDeposit && (
                <Button
                  onClick={() => onDeposit(account.id, account.bankName, account.accountNumber, account.routingNumber)}
                  className="greenButton"
                >
                  Deposit Here <i className="bi bi-coin"></i>
                </Button>
              )}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AccountList;